const escapeHtml = (s) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function formatAIText(text) {
  if (!text) return "";
  let html = escapeHtml(text);
  html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  html = html
    .split("\n")
    .map((line) => {
      const t = line.trim();
      if (/^-{3,}$/.test(t)) {
        return `<div class="border-t border-white/10 my-2"></div>`;
      }
      if (/^#{1,3} /.test(t)) {
        return `<div class="font-extrabold text-[14px] pt-1">${t.replace(/^#{1,3} /, "")}</div>`;
      }
      if (t.startsWith("- ") || t.startsWith("• ") || t.startsWith("* ")) {
        return `<div class="flex gap-2"><span class="text-[#f0a500] flex-shrink-0">•</span><span>${t.slice(2)}</span></div>`;
      }
      return t ? `<div>${t}</div>` : `<div class="h-2"></div>`;
    })
    .join("");
  return html;
}
